import React from "react";

export default function FooterSmall(props) {
  return (
    <>

      <footer
        className={
          (props.absolute
            ? "absolute w-full bottom-0 bg-blueGray-800"
            : " lg:z-50 lg:fixed self-center w-full bottom-0 bg-blueGray-800") + " pb-6"
        }
      >
        <div className="container mx-auto px-4 py-2">
          <hr className="border-b-1 border-transparent" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4">
              <div className="text-xs sd:text-sm text-blueGray-500 font-semibold  text-center md:text-left">
                Copyright © {new Date().getFullYear()}{" "}
                <a
                  href="/"
                  className="text-white hover:text-blueGray-300 text-sm font-semibold "
                >
                  DevToolsOnline.net
                </a>
              </div>
            </div>
            <div className="w-full md:w-8/12 px-4">
              <ul className="flex flex-wrap list-none md:justify-end  justify-center">
                <li>
                  <a
                    href="/privacy"
                    className="text-white hover:text-blueGray-300 text-sm font-semibold block py-1 px-3"
                  >
                    Privacy policy
                  </a>
                </li>
                <li>
                  <a
                    href="/about-us"
                    className="text-white hover:text-blueGray-300 text-sm font-semibold block py-1 px-3"
                  >
                    About Us
                  </a>
                </li>
                <li>
                  <a
                    href="/blog"
                    className="text-white hover:text-blueGray-300 text-sm font-semibold block py-1 px-3"
                  >
                    Blog
                  </a>
                </li>
                <li>
                  <a
                    href="https://opensource.org/licenses/MIT"
                    target="_blank"
                    rel="noreferrer"
                    className="text-white hover:text-blueGray-300 text-sm font-semibold block py-1 px-3"
                  >
                    MIT License
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
